<template>
    <v-text-field v-model='modelValue' variant="outlined" color="widget-color" @click.right.prevent @copy.prevent
        @paste.prevent :placeholder="$t('customer-info.general.input.email.title')" :rules="rules"
        validate-on="input lazy"></v-text-field>
</template>

<script setup>
import i18n from "@/i18n";
import isEmail from "validator/lib/isEmail";
import { computed, defineModel, defineProps } from "vue"
const modelValue = defineModel({
    required: true,
    type: String
})
const props = defineProps({
    email: String
})

const rules = computed(() => [
    (v) => {
        return !!v || i18n.global.t("customer-info.general.rules.required")
    },
    (v) => {
        return isEmail(v) || i18n.global.t("customer-info.general.rules.email.valid")
    },
    (v) => {
        if (props.email) {
            return v == props.email || i18n.global.t("customer-info.general.rules.email.retype")
        }
    }
])
</script>

<style lang="scss" scoped></style>